import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {
    TapestryButtonModule,
    TapestryChipsModule,
    TapestryIconModule,
    TapestryInlineMessageBoxModule,
    TapestryTooltipModule
} from '@predictiveindex/tapestry';
import { TranslationsModule } from '../../translations';
import { EmailChipInputComponent } from './email-chip-input-form.component';
import { EmailAutocompleteDisplayPipe } from './Pipes/email-autocomplete.display.pipe';
import { EmailChipDisplayPipe } from './Pipes/email-chip-display.pipe';
import { EmailCounterPipe } from './Pipes/email-counter.pipe';

@NgModule({
    imports: [
        CommonModule,
        TapestryChipsModule,
        TapestryButtonModule,
        TapestryIconModule,
        TapestryTooltipModule,
        TapestryInlineMessageBoxModule,
        TranslationsModule,
        ReactiveFormsModule,
        MatAutocompleteModule
    ],
    declarations: [
        EmailChipInputComponent,
        EmailCounterPipe,
        EmailChipDisplayPipe,
        EmailAutocompleteDisplayPipe
    ],
    exports: [EmailChipInputComponent],
    providers: []
})
export class EmailChipInputModule {}
